import UserInvoiceToPDF from "./UserInvoiceToPDF";
import { i18n } from '../../../lang/i18n';
import HelperProducts from "../../../common/HelperProducts";
import { LogoInline } from "../../../common/Conf";
import { useAppSelector } from "../../../store/hooks";

interface Props
{
    invoice: any,
    onClose: () => void
}

export default function UserInvoice(props: Props)
{
    const appConf = useAppSelector((state) => state.appConf)
    const appData = useAppSelector((state) => state.appData)
    const locationLegal= appData.location.legal
    const productExtras= appData.productExtras
    const invoice = props.invoice;

    return (<div className="users">
        <div className="container" style={{ border: '1px solid gainsboro', borderRadius: '5px', padding: '10px' }}>
            <div className="row text-center">
                <img className="header-logo pointer m-auto" alt="" data-code="home" src={LogoInline(appConf.iCl)} />
            </div>
            <div className="row">
                <div className="col-6">{locationLegal.name}</div>
                <div className="col-6 text-center">{i18n.CustomerInvoices.INVOICE}</div>
            </div>
            <div className="row">
                <div className="col-6">{locationLegal.address1}</div>
                <div className="col-6 text-right">{invoice.invoiceNumber}</div>
            </div>
            <div className="row">
                <div className="col-6">{locationLegal.address2}</div>
                <div className="col-6 text-right">{invoice.invoiceDate}</div>
            </div>
            <div className="row">
                <div className="col-6">{locationLegal.vatNumber}</div>
            </div>
            <hr className="mt-4"></hr>
            <div className="row">
                <div className="col-1"></div>
                <div className="col-6">{i18n.CustomerInvoices.PRODUCT}</div>
            </div>
            {invoice.products.map((item: any, index: number) => (
                <div className="row" key={index}>
                    <div className="col-1">{item.quantity}</div>
                    <div className="col-7">{HelperProducts.ProductDescription(productExtras, item)}</div>
                    <div className="col-4">{(item.price * item.quantity).toFixed(2)}€</div>
                </div>
            ))}
            <hr className="mb-4" />
            {invoice.loyaltyAmount > 0 && <div className="row">
                <div className="col-10 text-right">{i18n.CustomerInvoices.LoyaltyAmount}</div>
                <div className="col-2 text-right">{invoice.loyaltyPoints}⚡</div>
            </div>}
            {invoice.totalDiscount > 0 && <div className="row">
                <div className="col-10 text-right">{i18n.CustomerInvoices.Discount}</div>
                <div className="col-2 text-right">{invoice.totalDiscount.toFixed(2)}€</div>
            </div>}
            <div className="row">
                <div className="col-10 text-right">{i18n.CustomerInvoices.PriceTotalNet}</div>
                <div className="col-2 text-right">{invoice.totalPriceNet.toFixed(2)}€</div>
            </div>
            <div className="row">
                <div className="col-10 text-right">{i18n.CustomerInvoices.PriceTotalVat}</div>
                <div className="col-2 text-right">{invoice.totalPriceVat.toFixed(2)}€</div>
            </div>
            <div className="row">
                <div className="col-10 text-right">{i18n.CustomerInvoices.PriceTotal}</div>
                <div className="col-2 text-right">{invoice.totalPrice.toFixed(2)}€</div>
            </div>
            <div className="row">
                <div className="col"><hr /></div>
            </div>
            <div className="row">
                <div className="col-10 text-right">{i18n.CustomerInvoices.RitmitosAccumulated}</div>
                <div className="col-2 text-right">{invoice.ritmitosLoyalty}⚡</div>
            </div>
            <div className="row">
                <div className="col-10 text-right">{i18n.CustomerInvoices.RitmitosUsed}</div>
                <div className="col-2 text-right">{invoice.ritmitosUsed}⚡</div>
            </div>
        </div>

        <div className="container">
            <div className="row mb-5">
                <div className="col-12 text-right mt-2 mb-5">
                    <UserInvoiceToPDF item={invoice} productExtras={productExtras} locationLegal={locationLegal} />
                </div>
                <div className="col-12 mt-2">
                    <label className="btn-back link-btn btn-fixed-lb" onClick={props.onClose}
                    ><i className="fa fa-arrow-left" /> {i18n._BTNs.Back}</label>
                </div>
            </div>
        </div>
    </div>
    );
}